import { render, staticRenderFns } from "./related-movie.vue?vue&type=template&id=f09fd14a&scoped=true&lang=pug&"
import script from "./related-movie.vue?vue&type=script&lang=js&"
export * from "./related-movie.vue?vue&type=script&lang=js&"
import style0 from "./related-movie.vue?vue&type=style&index=0&id=f09fd14a&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09fd14a",
  null
  
)

export default component.exports